import { addMapMode, removeMapMode, setSelected } from 'client/store/mapSlice/mapSlice';
import { clearDrawStatus } from 'client/store/drawSlice/drawSlice';
import { mapModes } from 'client/utils/constants/appStates';
import { useDispatch, useSelector } from 'react-redux';
import { useContext } from 'react';
import { MapContext } from 'os-elements';
import { setAlertOpen } from 'client/store/alertSlice/alertSlice';

const { DEFAULT, DRAWING, MODIFYING, ADDING_OBSERVATION } = mapModes;

export function isAOIToClear (mapMode) {
    return mapMode.includes(DEFAULT) && !mapMode.includes(DRAWING);
}

export function useClearAOI () {
    const dispatch = useDispatch();
    const mapMode = useSelector(state => state.map.mode);
    const { map } = useContext(MapContext);

    return (optionalClearCallbackAction) => {
        map.getLayerById('draw')?.getSource().clear();
        dispatch(removeMapMode(DRAWING));
        dispatch(removeMapMode(ADDING_OBSERVATION));
        if (mapMode.includes(DEFAULT) || mapMode.includes(MODIFYING)) {
            map.getLayerById('aoi')?.getSource().clear();
        }
        if (mapMode.includes(MODIFYING)) {
            dispatch(removeMapMode(MODIFYING));
            dispatch(addMapMode(DEFAULT));
        }
        if (optionalClearCallbackAction) {
            optionalClearCallbackAction();
        }
        dispatch(setAlertOpen(false));
        dispatch(clearDrawStatus());
        dispatch(setSelected(null));
    };
}
